import { render, staticRenderFns } from "./pendingGroupRenewals.vue?vue&type=template&id=36ee29c2&"
import script from "./pendingGroupRenewals.vue?vue&type=script&lang=js&"
export * from "./pendingGroupRenewals.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/pending-details.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports